// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_3nHaS","button":"view-header_button_2BiA2","active":"view-header_active_y115F","btnExport":"view-header_btnExport_2ZLAi","mr":"view-header_mr_LXVsG"};